<div class="card card-info">
    <div class="card-header">
        <h3 class="card-title">Account & contact details</h3>

        <div adaptBlockingButtonGroup
             class="card-header-buttons">
            @if (!editMode) {
                <button adaptButton="edit"
                        (click)="editPerson()"></button>
            }
            @if (editMode) {
                <button adaptButton="save"
                        [adaptBlockingClick]="savePerson"></button>
            }
            @if (editMode) {
                <button adaptButton="cancel"
                        [adaptBlockingClick]="cancelPersonEdit"></button>
            }
        </div>
    </div>
    <div class="card-body row">
        @if (errorMessage) {
            <div role="alert"
                 class="alert alert-danger">
                {{ errorMessage }}
            </div>
        }
        <div class="col-md-6">
            <dl class="dl-horizontal">
                <dt>Person Id:</dt>
                <dd>{{ person.personId }}</dd>
            </dl>
            <dl class="dl-horizontal">
                <dt>Name:</dt>
                <dd>{{ person.fullName }}</dd>
            </dl>
            <dl class="dl-horizontal">
                <dt>Login Email Address:</dt>
                <dd>
                    <input id="emailInput"
                           name="emailInput"
                           class="form-control"
                           type="email"
                           required
                           [(ngModel)]="logInEmailAddress"
                           [disabled]="!editMode" />
                </dd>
            </dl>
        </div>
        <div class="col-md-6">
            <dl class="dl-horizontal">
                <dt>Phone:</dt>
                @for (phone of phones; track phone) {
                    <dd>
                        <adapt-contact-detail [detail]="phone"></adapt-contact-detail>
                    </dd>
                }
            </dl>
            <dl class="dl-horizontal">
                <dt>Email:</dt>
                @for (email of emails; track email) {
                    <dd>
                        <adapt-contact-detail [detail]="email"></adapt-contact-detail>
                    </dd>
                }
            </dl>
            <dl class="dl-horizontal">
                <dt>Address:</dt>
                @for (address of addresses; track address) {
                    <dd>
                        <adapt-contact-detail [detail]="address"></adapt-contact-detail>
                    </dd>
                }
            </dl>
        </div>
    </div>
</div>
